<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <!-- <div class="col-sm-6">
            <h1>Usage Details</h1>
          </div> -->
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Internet Usage</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-8">
            <div class="card">
              <div class="card-header">
                <a
                  href="javascript:void(0)"
                  class="btn btn-info"
                  @click="showFilter = !showFilter"
                  ><i class="fa fa-filter"></i>Filter</a
                >
              </div>
              <form @submit.prevent="getUsageData" method="GET" novalidate>
                <div class="card-body" v-if="showFilter">
                  <div class="form-row">
                    <div class="col-md-12">
                      <!-- Date range -->
                      <div class="form-group form-row">
                        <label class="col-md-3 col-form-label" for="created_at"
                          >Date range</label
                        >
                        <div class="col-md-9">
                          <date-picker
                            type="date"
                            input-class="form-control"
                            v-model="filter"
                            range
                            lang="en"
                            format="DD-MM-YYYY"
                            confirm
                            id="created_at"
                            value-type="DD-MM-YYYY"
                          ></date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-9 offset-md-3">
                          <button type="submit" class="btn btn-common m-2px">
                            <i class="fas fa-search"></i> Search
                          </button>
                          <button
                            type="reset"
                            class="btn btn-warning"
                            @click="resetFilter()"
                          >
                            <i class="fas fa-undo"></i> Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="overlay" v-if="list.is_loading">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
              </div>

              <div class="col-md-12 card-body pt-0 pb-2">
                <div
                  class="custom-list history-list"
                  v-for="(item, index) in list.data"
                  :key="item.id"
                >
                  <ul>
                    <li>
                      <strong> {{ "Date" }} </strong>
                      {{ item.date }}
                    </li>

                    <li>
                      <strong> {{ "Upload(MB)" }} </strong>
                      {{ item.upload }}
                    </li>

                    <li>
                      <strong> {{ "Download(MB)" }} </strong>
                      {{ item.download }}
                    </li>

                    <li>
                      <strong> {{ "Total(MB)" }} </strong>
                      {{ item.total }}
                    </li>
                  </ul>
                </div>

                <div
                  class="p-4"
                  v-if="_.isEmpty(list.data) && !list.is_loading"
                >
                  <div class="alert alert-default-warning" role="alert">
                    No data found!
                  </div>
                </div>
              </div>

              <div class="card-footer">
                <vue-pagination
                  :pagination="list"
                  v-if="list.total > list.per_page"
                  @paginate="getUsageData()"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card data-usages">
              <div class="card-header">Total usages</div>
              <div class="card-body">
                <div class="data-usages-box">
                  <!-- <h4>500GB <span>Till 07 May 2023</span></h4> -->
                  <h4>
                    {{ totalUsageData.totalUsage }}GB
                    <span>Till {{ totalUsageData.uptoDate }}</span>
                  </h4>
                </div>
                <div class="data-usages-chart">
                  <UsagesChart :chartDataProps="chartData"></UsagesChart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import { CommonAPI } from "@/services/api";
const fileDownload = require("js-file-download");
import { Notification } from "element-ui";
import UsagesChart from "@/views/SelfCare/UsagesChart";

export default {
  name: "DataUsage",
  metaInfo: {
    title: "Data Usage | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
    SwipeList,
    SwipeOut,
    UsagesChart,
  },

  data: () => ({
    totalUsageData: {
      uptoDate: "",
      totalUsage: 0, // total usage in GB
    },

    chartData: {
      labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
      datasets: [
        {
          label: "Total Usages (GB)",
          backgroundColor: "#F5F5FA",
          hoverBackgroundColor: "#194F9F",
          data: [40, 20, 12, 39, 10, 40, 39],
        },
      ],
    },

    list: {
      is_loading: true,
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      data: [],
      totalUsage: 0,
    },
    order_by: "asc",
    api_url: "",
    showFilter: false,
    // filter: { startDate: '', endDate: ''},
    filter: [],
    dateRange: "",
    pre: [],
    is_loading: false,
    has_permission: true,
  }),
  // method is called after page load
  mounted: function () {
    if (this.isMobile()) {
      var openOrClose = window.$(document).find(".sidebar-mini");
      if ($(openOrClose).hasClass("sidebar-open")) {
        window.$(document).find(".push-menu-class").trigger("click");
      }
    }

    this.api_url = "/admin_users";
    this.getUsageData();
    this.getTotalUsage();
    this.getLastWeekUsage();
    // this.getOrganization();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.getUsageData();
    });
  },

  methods: {
    getTotalUsage: function () {
      let _this = this;
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (subscriber) {
        axios
          .get("/get_total_usage", { params: { cuid: subscriber.username } })
          .then((response) => {
            console.log("Response::", response.data);
            let data = response.data;
            if (data) {
              _this.totalUsageData = data;
            }
          })
          .catch((error) => {
            console.log("Error::", error);
          })
          .finally((error) => {});
      }
    },

    getLastWeekUsage: function () {
      let _this = this;
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (subscriber) {
        axios
          .get("/get_last_week_usages", {
            params: { cuid: subscriber.username },
          })
          .then((response) => {
            console.log("Response::", response.data);
            let data = response.data;
            if (data) {
              let daysOfWeek = Object.keys(data);
              let values = Object.values(data);
              _this.chartData.labels = daysOfWeek;
              _this.chartData.datasets[0].data = [];
              _this.chartData.datasets[0].data.push(values);
            }
          })
          .catch((error) => {
            console.log("Error::", error);
          })
          .finally((error) => {});
      }
    },

    itemClick(e) {
      console.log(e, "item click");
    },

    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },

    getUsageData() {
      this.is_loading = true;

      // this.list.data = [
      //       {
      //         date: '12/02/2022', upload: 200, download: 100, total: 300
      //       },
      //   ];

      this.is_loading = true;
      let query = { ...this.filter, ...this.$route.query };
      let api_url = "/get-usage";
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (subscriber) {
        query.cuid = subscriber.username;
        axios
          .get(api_url, {
            params: query,
          })
          .then((response) => {
            //console.log('response.data::', response.data);
            this.list = response.data;
            this.list.data = this.list.data.map((o) => {
              o.download = parseFloat(
                o.download / (1024 * 1024)
              ).toLocaleString("en-US", { maximumFractionDigits: 2 });
              o.upload = parseFloat(o.upload / (1024 * 1024)).toLocaleString(
                "en-US",
                { maximumFractionDigits: 2 }
              );
              o.total = parseFloat(o.total / (1024 * 1024)).toLocaleString(
                "en-US",
                { maximumFractionDigits: 2 }
              );
              o.date = moment(o.date).format("DD MMM YYYY");
              return o;
            });

            this.is_loading = false;
          })
          .catch((error) => {
            console.log("error " + error);
            this.is_loading = false;
          });
      }
    },

    resetFilter() {
      const query = Object.assign({}, this.$route.query);
      if (Object.keys(query).length > 0) {
        delete query.order_by;
        delete query.order_key;
        delete query.page;
        // Object.keys(query).forEach((key) => delete query.key);
        this.$router.replace({ query });
      }
      this.filter = {};
      this.getUsageData();
    },
  },
};
</script>
